<template lang="html">
  <div class="shopify-locate-channels">
    <Guide
      :content="content"
      contentHeading="Open Sales Channels"
      :contentImage="contentImage"
      :closeLink="closeLink"
      :nextLink="nextLink"
      :previousLink="previousLink"/>
  </div>
</template>

<script>
import Guide from '@/components/Guide'

export default {
  name: 'ShopifyLocateChannels',

  components: {
    Guide
  },

  props: {
    siteId: String,
    companyId: String
  },

  computed: {
    closeLink() {
      return {
        name: 'shopify-settings',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    nextLink() {
      return {
        name: 'remove-sales-channel',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    previousLink() {
      return {
        name: 'create-store',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    content() {
      return `
          <p>We highly recommend removing the <strong>Online Store</strong> sales channel as the <a href="https://www.shopify.co.uk/lite" target="_blank">Shopify Lite</a> plan is required and only becomes available once the online store channel has been removed.</strong></p>

          <p>Remove the <strong>Online Store</strong> sales channel by visiting the <a class="btn is-tertiary" href="https://www.shopify.com/admin/settings/channels" target="_blank">Sales Channels</a> page. Proceed once you have loaded this page.</p>
        `
    },

    contentImage() {
      return 'https://cdn.shopify.com/assets2/channels/online-marketplaces-large-cc1d45f003c5bede01a823c50b81c7dbf9972ff0ede5581070784f848bcc5510.jpg'
    }
  }
}
</script>

<style lang="sass">
  .shopify-guide
</style>
